import {type FC, memo, type PropsWithChildren, useCallback} from 'react';
import {Link, useNavigate} from 'react-router';

import classNames from 'classnames';

import {useI18n} from '@yourcoach/i18n';
import ArrowBackIcon from '@yourcoach/shared/assets/icons/arrow-back.svg';
import {Logo} from '@yourcoach/shared/uikit/Logo';

import Button from '@src/components/Button';
import {routerPath} from '@src/routes/path';

import styles from './LogoOnly.module.css';

interface Props {
  backButtonText?: string;
  className?: string;
  contentClassName?: string;
  onBackButtonClick?: () => void;
  v2?: boolean;
  withBackButton?: boolean;
}

const LogoOnlyLayout: FC<PropsWithChildren<Props>> = ({
  backButtonText,
  children,
  className,
  contentClassName,
  onBackButtonClick,
  v2,
  withBackButton,
}) => {
  const {t} = useI18n();
  const navigate = useNavigate();

  const onBackButtonClickCb = useCallback(() => {
    if (onBackButtonClick) {
      onBackButtonClick();
    } else {
      navigate(-1);
    }
  }, [navigate, onBackButtonClick]);

  return (
    <section
      className={classNames(
        'LogoOnlyLayout',
        `${styles.LogoOnlyLayout}`,
        v2 && styles.v2,
        className,
      )}
    >
      <div className={styles.header}>
        <Link className={styles.logoContainer} to={routerPath.$buildPath({})}>
          <Logo size={40} />
        </Link>
        <div className={styles.headerRightPart}>
          {withBackButton ? (
            <Button className={styles.backButton} onClick={onBackButtonClickCb}>
              <ArrowBackIcon />
              <span>{backButtonText || t('shared:back')}</span>
            </Button>
          ) : null}
        </div>
      </div>
      <section className={classNames(styles.content, contentClassName)}>
        {children}
      </section>
    </section>
  );
};

export default memo(LogoOnlyLayout);
